import React from "react";
import Iframe from "./Iframe";
const IframeUrl = (props) => /* @__PURE__ */ React.createElement(
  Iframe,
  {
    ...props,
    sandbox: "allow-popups allow-presentation allow-forms allow-same-origin allow-scripts"
  }
);
var IframeUrl_default = IframeUrl;
export {
  IframeUrl_default as default
};
//# sourceMappingURL=IframeUrl.js.map
